import React from 'react';

const SellerDisclosure = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Seller Disclosure
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Seller knows of no facts materially affecting the value of the Real
          Property which are not readily observable and which have not been
          disclosed to Buyer. Except as provided for in the preceding sentence,
          Seller extends and intends no warranty and makes no representation of
          any type, either express or implied, as to the physical condition or
          history of the Property. Except as otherwise disclosed in writing
          Seller has received no written or verbal notice from any governmental
          entity or agency as to a currently uncorrected building, environmental
          or safety code violation.
        </li>
      </ol>
    </div>
  );
};

export default SellerDisclosure;
